// src/Components/VideoCard/VideoCard.tsx

import React, { FunctionComponent } from "react";
import "./VideoCard.scss";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";

// Assuming you have SVG components or can use these placeholders
const BookIcon = () => (
  <svg className="book-icon" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M21 18v1c-1.39-.77-2.85-1.25-4.39-1.44v-1.47c1.54.19 3.01.67 4.39 1.44zm-4.39-4.22c-2.39-.71-4.79-1.12-7.11-1.12s-4.72.41-7.11 1.12c-1.19.35-2.09.84-2.09 1.41v4.75c0 .28 1.15.54 2.82.78 1.17.17 2.4.26 3.65.26 1.26 0 2.48-.09 3.65-.26 1.67-.24 2.82-.5 2.82-.78v-4.75c0-.57-.9-1.06-2.09-1.41zM21 4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6.5C4 6.22 5.09 6 6.5 6S9 6.22 9 6.5V9H4V6.5zm5 5h-5V9h5v2.5zm-5 4V13h5v2.5H4zm13.5 0h-5V13h5v2.5zM17.5 9h-5V6.5h5V9zM19 6.5c0-.28-1.09-.5-2.5-.5S14 6.22 14 6.5V9h5V6.5z"
    />
  </svg>
);

const PlayIcon = () => (
  <svg className="play-icon" viewBox="0 0 24 24">
    <path fill="currentColor" d="M8 5v14l11-7z" />
  </svg>
);

interface VideoCardProps {
  imageSrc: string;
  duration?: string;
  title: string;
  description: string;
  videoCount: number;
  completion: number;
  topic_count?: number;
  buttonText: string;
  onCardClick?: () => void; // Updated prop for card click
}

const VideoCard: FunctionComponent<VideoCardProps> = ({
  imageSrc,
  duration,
  title,
  description,
  videoCount,
  completion,
  buttonText,
  topic_count,
  onCardClick, // Renamed prop
}) => {
  return (
    <div className="video-card" onClick={onCardClick}>
      {" "}
      {/* The entire card is now clickable */}
      <div className="video-card__thumbnail-wrapper">
        <div className="video-card-image"></div>
        <img src={imageSrc} alt={title} className="video-card__thumbnail" />

        {duration && (
          <span className="video-card__duration">
            {" "}
            <AccessTimeIcon sx={{ fontSize: "14px" }} />
            {duration}
          </span>
        )}
        <div className="video-card__play-button">
          {/* <PlayIcon /> */}
          <PlayArrowOutlinedIcon sx={{ color: "#fff", fontSize: "26px" }} />
        </div>
      </div>
      <div className="video-card__content">
        <h3 className="video-card__title">{title}</h3>
        <p className="video-card__description">{description}</p>

        <div>
          <div className="video-card__info">
            <span className="video-card__video-count">
              {topic_count ? (
                <>
                  {topic_count > 1
                    ? `${topic_count} Topics`
                    : `${topic_count} Topic`}
                </>
              ) : (
                <>
                  <BookIcon />
                  {videoCount} videos
                </>
              )}
            </span>
            {!topic_count && (
              <span className="video-card__completion">
                {completion}% complete
              </span>
            )}
          </div>
          {!topic_count && (
            <div className="video-card__progress-bar-container">
              <div
                className="video-card__progress-bar"
                style={{ width: `${completion}%` }}
              ></div>
            </div>
          )}
          {/* The button can still exist for a different action if needed, or you can just remove it */}
          <button className="video-card__button" onClick={onCardClick}>
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
